<template>
  <div class="change-category-path">
    <div class="category-text-wrapper">
      <div class="category-text" :class="cashflowCategory">
        מ{{ categoryName }}
        <div class="expense-name">{{ oldExpenseCategory }}</div>
      </div>
      <div class="category-text left" :class="cashflowCategory">
        ל{{ categoryName }}
        <div class="expense-name">{{ newExpenseCategory }}</div>
      </div>
    </div>
    <div class="category-path">
      <div class="circle" :class="cashflowCategory"></div>
      <div class="gradient-line" :class="[`right-${cashflowCategory}`, `left-${cashflowCategory}`]"></div>
      <div class="left-arrow fa fa-caret-left" :class="cashflowCategory"></div>
      <div class="circle" :class="cashflowCategory"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ChangeExpenseCategoryPath',
  props: {
    cashflowCategory: {
      type: String,
      required: true,
    },
    categoryName: {
      type: String,
      required: true,
    },
    oldExpenseCategory: {
      type: String,
      required: true,
    },
    newExpenseCategory: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../scss/category-color-mixins';

  .change-category-path {
    direction: rtl;

    .category-text-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 4px;

      .category-text {
        font-size: 16px;
        line-height: 16px;
        font-family: SimplerPro;
        font-weight: bold;

        @include category-color;

        &.left {
          text-align: left;
        }

        .expense-name {
          margin-top: 2px;
          font-weight: normal;
        }
      }
    }

    .category-path {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .gradient-line {
        height: 1px;
        width: 85%;

        &.right-recurring {
          &.left-variable {
            background: linear-gradient(to left, $riseup_light_blue, $riseup_mustard),
          }

          &.left-recurring {
            background: linear-gradient(to left, $riseup_light_blue, $riseup_light_blue),
          }

          &.left-fixed {
            background: linear-gradient(to left, $riseup_light_blue, $riseup_coral),
          }
        }

        &.right-variable {
          &.left-recurring {
            background: linear-gradient(to left, $riseup_mustard, $riseup_light_blue),
          }

          &.left-variable {
            background: linear-gradient(to left, $riseup_mustard, $riseup_mustard),
          }

          &.left-fixed {
            background: linear-gradient(to left, $riseup_mustard, $riseup_coral),
          }
        }

        &.right-fixed {
          &.left-recurring {
            background: linear-gradient(to left, $riseup_coral, $riseup_light_blue),
          }

          &.left-variable {
            background: linear-gradient(to left, $riseup_coral, $riseup_mustard),
          }

          &.left-fixed {
            background: linear-gradient(to left, $riseup_coral, $riseup_coral),
          }
        }
      }

      .left-arrow {
        color: $riseup_mustard;
        transform: scale(1.5,1);
        margin-left: 1px;

        @include category-color;
      }

      .circle {
        width: 16px;
        height: 16px;
        border-radius: 50%;

        @include category-background-color;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/ChangeExpenseCategoryPath.vue